(function(){
  if(window.MOGA_HELP_V3_LOADED) return;
  window.MOGA_HELP_V3_LOADED=true;

  function panel(){ return document.getElementById('mogaHelpPanel'); }
  function lightbox(){ return document.getElementById('mogaHelpLightbox'); }

  function init(){
    var p=panel();
    if(!p) return;

    var buttons=Array.prototype.slice.call(p.querySelectorAll('[data-help-filter]'));
    var cards=Array.prototype.slice.call(p.querySelectorAll('[data-help-card]'));
    var search=document.getElementById('mogaHelpSearch');
    var empty=document.getElementById('mogaHelpEmpty');
    var current='all';

    function applyFilter(){
      var q=(search && search.value ? search.value : '').trim().toLowerCase();
      var visible=0;

      cards.forEach(function(card){
        var cats=(card.getAttribute('data-help-cat')||'').toLowerCase().split(/\s+/);
        var text=(card.textContent||'').toLowerCase();
        var okCategory=(current==='all'||cats.indexOf(current)!==-1);
        var okSearch=(!q||text.indexOf(q)!==-1);
        var show=okCategory&&okSearch;

        card.classList.toggle('moga-help-filter-hidden', !show);
        if(show) visible++;
      });

      if(empty) empty.style.display=visible ? 'none' : 'block';
    }

    buttons.forEach(function(btn){
      btn.onclick=function(e){
        e.preventDefault();
        current=(btn.getAttribute('data-help-filter')||'all').toLowerCase();
        buttons.forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        applyFilter();
      };
    });

    if(search){
      search.oninput=applyFilter;
      search.onsearch=applyFilter;
    }

    p.querySelectorAll('.moga-help-image').forEach(function(btn){
      btn.onclick=function(){
        var lb=lightbox();
        var img=lb && lb.querySelector('img');
        if(lb && img){
          img.src=btn.getAttribute('data-help-img')||'';
          lb.classList.add('open');
          lb.setAttribute('aria-hidden','false');
        }
      };
    });

    var lb=lightbox();
    if(lb){
      var close=lb.querySelector('button');
      if(close) close.onclick=function(){lb.classList.remove('open');lb.setAttribute('aria-hidden','true');};
      lb.onclick=function(e){if(e.target===lb){lb.classList.remove('open');lb.setAttribute('aria-hidden','true');}};
    }

    window.MOGA_HELP={
      open:function(){
        p.classList.add('open');
        p.setAttribute('aria-hidden','false');
        var hb=document.getElementById('helpBtn');
        if(hb) hb.classList.add('active');
        document.body.style.overflow='hidden';
        applyFilter();
      },
      close:function(){
        p.classList.remove('open');
        p.setAttribute('aria-hidden','true');
        var hb=document.getElementById('helpBtn');
        if(hb) hb.classList.remove('active');
        if(lb) lb.classList.remove('open');
        document.body.style.overflow='';
      }
    };

    var hb=document.getElementById('helpBtn');
    if(hb) hb.textContent='KAIP NAUDOTIS?';

    p.onclick=function(e){
      if(e.target===p) window.MOGA_HELP.close();
    };

    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'){
        if(lb && lb.classList.contains('open')) lb.classList.remove('open');
        else if(p.classList.contains('open')) window.MOGA_HELP.close();
      }
    });

    applyFilter();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();